import Rest from '../Rest'

export default class DocumentPeopleService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/document_people'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
